"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var link_icon_svg_1 = __importDefault(require("@assets/components/user/user-link-table/link-icon.svg"));
var file_icon_svg_1 = __importDefault(require("@assets/components/user/user-link-table/file-icon.svg"));
var click_count_icon_svg_1 = __importDefault(require("@assets/components/user/user-link-table/click-count-icon.svg"));
var react_i18next_1 = require("react-i18next");
var TableTag_1 = __importDefault(require("./TableTag"));
var actions_1 = __importDefault(require("../../../../actions"));
var appMargins_1 = __importDefault(require("../../../../../app/components/AppMargins/appMargins"));
var reducers_1 = require("../../../Drawer/ControlPanel/util/reducers");
var Drawer_1 = require("../../../Drawer");
var format_1 = require("../../../../../app/util/format");
var CopyButton_1 = __importDefault(require("../../../../widgets/CopyButton"));
var constants_1 = require("../../../../../../shared/constants");
var AppMargins_1 = require("../../../../../app/components/AppMargins");
var StatusIcon_1 = __importDefault(require("../../../../widgets/StatusIcon"));
var useStyles = styles_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    return styles_1.createStyles({
        bar: {
            backgroundColor: theme.palette.grey[500],
        },
        tableHeader: (_a = {
                backgroundColor: theme.palette.primary.main,
                '& th': {
                    textAlign: 'center',
                    border: 'none',
                },
                '& th:first-child': {
                    borderRadius: '8px 0px 0px 0px',
                },
                '& tr': {
                    display: 'table-row',
                    height: 'auto',
                },
                '& th:last-child': {
                    borderRadius: '0px 8px 0px 0px',
                }
            },
            _a[theme.breakpoints.down('sm')] = {
                '& tr': {
                    border: 'none',
                },
            },
            _a),
        headerCell: {
            color: '#C9CED6',
        },
        root: {
            marginBottom: theme.spacing(2),
            border: 'none',
            borderSpacing: '0 0 15px 0',
            '&:first-child': {
                borderTop: 'none',
            },
            '& tr': {
                padding: 0,
            },
        },
        tableRowPaper: {
            border: 'none',
            borderRadius: 0,
            marginBottom: '15px',
            width: '100%',
        },
        leftCellHeader: (_b = {
                color: '#C9CED6'
            },
            _b[theme.breakpoints.up('md')] = {
                textAlign: 'end',
                paddingTop: '0px',
                paddingRight: theme.spacing(1.5),
                paddingLeft: function (props) { return props.appMargins - 90; },
            },
            _b),
        leftCell: (_c = {},
            _c[theme.breakpoints.up('md')] = {
                textAlign: 'end',
                paddingTop: '0px',
                paddingRight: theme.spacing(1.5),
                paddingLeft: function (props) { return props.appMargins - 90; },
            },
            _c[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _c),
        leftCellWithTags: (_d = {},
            _d[theme.breakpoints.up('md')] = {
                textAlign: 'end',
                paddingTop: '0px',
                paddingRight: theme.spacing(1.5),
                paddingBottom: '61px',
                paddingLeft: function (props) { return props.appMargins - 90; },
            },
            _d[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _d),
        urlCellHeader: (_e = {
                color: '#C9CED6',
                paddingTop: theme.spacing(3)
            },
            _e[theme.breakpoints.up('md')] = {
                width: '61%',
            },
            _e[theme.breakpoints.down('sm')] = {
                width: '20%',
                padding: theme.spacing(1, 1, 2, 1),
            },
            _e),
        urlCell: (_f = {
                paddingTop: theme.spacing(3)
            },
            _f[theme.breakpoints.up('md')] = {
                width: '61%',
            },
            _f[theme.breakpoints.down('sm')] = {
                display: 'inline-flex',
                width: '100%',
                padding: theme.spacing(2, 2, 0, 3),
                paddingLeft: function (props) { return props.appMargins; },
            },
            _f),
        shortUrlGrid: (_g = {},
            _g[theme.breakpoints.down('sm')] = {
                width: '100%',
            },
            _g),
        longUrlGrid: {
            padding: theme.spacing(1, 0, 0.5, 0),
        },
        stateCellHeader: (_h = {
                color: '#C9CED6',
                width: '20%'
            },
            _h[theme.breakpoints.up('md')] = {
                minWidth: '100px',
            },
            _h),
        stateCell: (_j = {
                width: '20%'
            },
            _j[theme.breakpoints.up('md')] = {
                minWidth: '100px',
            },
            _j[theme.breakpoints.down('sm')] = {
                display: 'inline-flex',
                padding: theme.spacing(1, 2, 2, 3),
                width: '30%',
                minWidth: '110px',
                paddingLeft: function (props) { return props.appMargins; },
            },
            _j),
        createdAtCellHeader: (_k = {
                color: '#C9CED6'
            },
            _k[theme.breakpoints.up('md')] = {
                minWidth: '140px',
            },
            _k[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(1, 1, 2, 1),
                width: '80%',
                textAlign: 'left',
            },
            _k),
        createdAtCell: (_l = {
                justifyContent: 'center'
            },
            _l[theme.breakpoints.up('md')] = {
                minWidth: '125px',
            },
            _l[theme.breakpoints.down('sm')] = {
                display: 'inline-flex',
                padding: theme.spacing(1, 0, 2, 0),
                width: '30%',
                minWidth: '100px',
            },
            _l[theme.breakpoints.down('xs')] = {
                width: '25%',
            },
            _l),
        clicksCellHeader: (_m = {
                color: '#C9CED6',
                paddingRight: function (props) { return props.appMargins; }
            },
            _m[theme.breakpoints.up('md')] = {
                minWidth: '210px',
            },
            _m[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(1, 0, 2, 2),
                paddingRight: 0,
                width: '100%',
                minWidth: '50px',
            },
            _m),
        clicksCell: (_o = {},
            _o[theme.breakpoints.up('md')] = {
                paddingRight: function (props) { return props.appMargins; },
                minWidth: '210px',
            },
            _o[theme.breakpoints.down('sm')] = {
                display: 'inline-flex',
                padding: theme.spacing(1, 0, 2, 2),
                width: '40%',
                minWidth: '100px',
                justifyContent: 'center',
            },
            _o[theme.breakpoints.down('xs')] = {
                width: '30%',
            },
            _o),
        clicksCellContent: {
            width: 118,
        },
        clicksCellTooltipContent: {
            display: 'inline-block',
            float: 'right',
        },
        rightCell: (_p = {},
            _p[theme.breakpoints.up('md')] = {
                textAlign: 'right',
                paddingRight: function (props) { return props.appMargins; },
            },
            _p),
        icon: (_q = {
                marginTop: theme.spacing(-0.5)
            },
            _q[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _q),
        stateActive: {
            color: constants_1.THEME_COLOR.STATE_ACTIVE,
            textTransform: 'capitalize',
            fontSize: 14,
            marginRight: 10,
        },
        stateInactive: {
            color: constants_1.THEME_COLOR.STATE_INACTIVE,
            textTransform: 'capitalize',
            fontSize: 14,
            marginRight: 10,
        },
        shortUrl: (_r = {},
            _r[theme.breakpoints.down('sm')] = {
                width: 'calc(100% - 32px)',
            },
            _r.whiteSpace = 'nowrap',
            _r.overflow = 'hidden',
            _r.textOverflow = 'ellipsis',
            _r),
        longUrl: {
            color: theme.palette.primary.main,
        },
        createdAt: {
            color: theme.palette.primary.main,
        },
        clicksIcon: {
            verticalAlign: 'middle',
        },
        clicksText: {
            color: theme.palette.primary.main,
            paddingRight: '4px',
        },
        hoverRow: (_s = {
                border: 'none'
            },
            _s[theme.breakpoints.down('sm')] = {
                height: 'auto',
            },
            _s['&:hover'] = {
                backgroundColor: theme.palette.background.default,
                cursor: 'pointer',
            },
            _s),
        lastCreatedRow: {
            backgroundColor: theme.palette.background.default,
        },
    });
});
function EnhancedTableBody() {
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var urls = react_redux_1.useSelector(function (state) { return state.user.urls; });
    var tableConfig = react_redux_1.useSelector(function (state) { return state.user.tableConfig; });
    var lastCreatedLink = react_redux_1.useSelector(function (state) { return state.user.lastCreatedLink; });
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    var dispatch = react_redux_1.useDispatch();
    var drawerDispatch = Drawer_1.useDrawerDispatch();
    var openControlPanel = function (shortlink) {
        return drawerDispatch({ type: reducers_1.DrawerActions.openControlPanel, payload: shortlink });
    };
    var setSearchByTag = function (tag) {
        var newSearchInput = tableConfig.isTag && tableConfig.searchInput
            ? "" + tableConfig.searchInput + constants_1.TAG_SEPARATOR + tag // append tag to existing tags in search input
            : tag;
        var newConfig = {
            isTag: true,
            searchInput: newSearchInput,
        };
        dispatch(actions_1.default.setUrlTableConfig(newConfig));
    };
    if (urls.length > 0) {
        // If user has existing links, show the user's list of stored links.
        return (react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
            react_1.default.createElement(core_1.Table, { "aria-label": "table with urls" },
                react_1.default.createElement(core_1.TableHead, { classes: { root: classes.tableHeader } },
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { className: classes.leftCellHeader }, " "),
                        react_1.default.createElement(core_1.TableCell, { align: "left", className: classes.urlCellHeader }, t('text.link')),
                        react_1.default.createElement(core_1.Hidden, { smDown: true },
                            react_1.default.createElement(core_1.TableCell, { className: classes.stateCellHeader })),
                        react_1.default.createElement(core_1.Hidden, { smDown: true },
                            react_1.default.createElement(core_1.TableCell, { className: classes.stateCellHeader }, t('text.status'))),
                        react_1.default.createElement(core_1.TableCell, { className: classes.createdAtCellHeader }, t('text.date')),
                        react_1.default.createElement(core_1.TableCell, { className: classes.clicksCellHeader }, t('text.click'))))),
            react_1.default.createElement(core_1.Table, { "aria-label": "table with urls" },
                react_1.default.createElement(core_1.TableBody, { classes: { root: classes.root } }, urls.map(function (row) { return (react_1.default.createElement(core_1.TableRow, { key: row.shortUrl, className: classes.hoverRow + " " + (lastCreatedLink === row.shortUrl ? classes.lastCreatedRow : ''), onClick: function () { return openControlPanel(row.shortUrl); } },
                    react_1.default.createElement(core_1.Paper, { elevation: 0, className: classes.tableRowPaper },
                        react_1.default.createElement(core_1.TableCell, { className: row.tags.length > 0
                                ? classes.leftCellWithTags
                                : classes.leftCell },
                            react_1.default.createElement("img", { className: classes.icon, src: row.isFile ? file_icon_svg_1.default : link_icon_svg_1.default, alt: row.isFile ? 'File' : 'Link' })),
                        react_1.default.createElement(core_1.TableCell, { align: "left", className: classes.urlCell },
                            react_1.default.createElement(core_1.Grid, { container: true, direction: "column" },
                                react_1.default.createElement(core_1.Grid, { item: true, className: classes.shortUrlGrid },
                                    react_1.default.createElement(core_1.Tooltip, { title: row.shortUrl, placement: "top-start", arrow: true },
                                        react_1.default.createElement(core_1.Typography, { variant: "h6", className: classes.shortUrl },
                                            "/",
                                            row.shortUrl))),
                                react_1.default.createElement(core_1.Hidden, { smDown: true },
                                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.longUrlGrid },
                                        react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.longUrl }, row.longUrl))),
                                row.tags.length > 0 && (react_1.default.createElement(core_1.Hidden, { smDown: true },
                                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.longUrlGrid }, row.tags.map(function (tag) { return (react_1.default.createElement(TableTag_1.default, { key: tag, tag: tag, onClick: function () { return setSearchByTag(tag); } })); })))))),
                        react_1.default.createElement(core_1.Hidden, { smDown: true },
                            react_1.default.createElement(core_1.TableCell, { className: classes.stateCell, style: { width: 'unset' } },
                                react_1.default.createElement(CopyButton_1.default, { shortUrl: row.shortUrl, showButtonText: false, iconSize: 35, variant: "caption", stopPropagation: true }))),
                        react_1.default.createElement(core_1.TableCell, { className: classes.stateCell },
                            react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "center" },
                                react_1.default.createElement(core_1.Typography, { variant: "caption", className: row.state === 'ACTIVE'
                                        ? classes.stateActive
                                        : classes.stateInactive }, row.state === 'ACTIVE'
                                    ? t('text.active')
                                    : t('text.inactive')),
                                react_1.default.createElement(StatusIcon_1.default, { state: row.state }))),
                        react_1.default.createElement(core_1.TableCell, { className: classes.createdAtCell },
                            react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.createdAt }, row.createdAt)),
                        react_1.default.createElement(core_1.TableCell, { className: classes.clicksCell },
                            react_1.default.createElement("div", { className: classes.clicksCellContent },
                                react_1.default.createElement(core_1.Tooltip, { title: row.clicks, placement: "top", arrow: true },
                                    react_1.default.createElement("div", { className: classes.clicksCellTooltipContent },
                                        react_1.default.createElement("img", { className: classes.clicksIcon, src: click_count_icon_svg_1.default, alt: "Clicks" }),
                                        react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.clicksText }, format_1.numberUnitFormatter(row.clicks))))))))); })))));
    }
    // To return if user does not have any existing links.
    return (react_1.default.createElement(core_1.TableBody, null,
        react_1.default.createElement(core_1.TableRow, null,
            react_1.default.createElement(core_1.TableCell, { className: classes.leftCell }, t('text.noLinkfound')),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, { className: classes.rightCell }))));
}
exports.default = EnhancedTableBody;
